import * as React from 'react'
import Dropzone from 'react-dropzone'
import { inject, observer } from 'mobx-react'
import { Modal, ModalHeader, ModalBody } from 'reactstrap'
import { CurrentCompanyStore } from '../stores/CurrentCompanyStore'
import { uploadImageToCloudinary } from '../utilities/helpers'

export interface CloudinaryResponse {
  public_id: string
  version: number
  signature: string
  width: number
  height: number
  format: string
  resource_type: string
  created_at: Date
  tags: string[]
  bytes: number
  type: string
  etag: string
  placeholder: boolean
  url: string
  secure_url: string
  original_filename: string
}

interface Props {
  currentCompanyStore?: CurrentCompanyStore
  isOpen: boolean
  onHide: () => void
  onUpload: (uploadObject: { imageUrl: string }) => void
}

interface State {
  isUploading: boolean
  imageUrl: string
}

@inject('currentCompanyStore')
@observer
export class ImageUploadModal extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props)
    this.state = {
      isUploading: false,
      imageUrl: '',
    }
  }

  hide() {
    this.setState({ isUploading: false })
    this.props.onHide()
  }

  async onDrop(files: any[]) {
    if (files.length > 0) {
      const file = files[0]

      this.setState({ isUploading: true })

      try {
        const uploadUrlDetails =
          await this.props.currentCompanyStore!.getSignedImageUploadPublicUrl()

        const { xhr, formData } = uploadImageToCloudinary(file, uploadUrlDetails)

        xhr.onload = () => {
          this.setState({ isUploading: false })
          if (xhr.status === 200) {
            const responseData: CloudinaryResponse = JSON.parse(xhr.responseText)
            this.props.onUpload({
              imageUrl: responseData.secure_url,
            })
          } else {
            throw new Error(xhr.statusText)
          }
        }
        xhr.send(formData)
      } catch (error) {
        console.error(error)
      }
    }

    // If user tries to drag an image url

    // const url = ''
    // const callback = (result: any) => {}
    // const xhr = new XMLHttpRequest()
    // xhr.onload = () => {
    //   var reader = new FileReader()
    //   reader.onloadend = () => {
    //     callback(reader.result)
    //   }
    //   reader.readAsDataURL(xhr.response)
    // }
    // xhr.open('GET', url)
    // xhr.responseType = 'blob'
    // xhr.send()
  }

  saveImageUrl() {
    this.props.onUpload({
      imageUrl: this.state.imageUrl!,
    })
  }

  render() {
    return (
      <Modal isOpen={this.props.isOpen} toggle={() => this.hide()}>
        <ModalHeader toggle={() => this.hide()}>Upload image</ModalHeader>
        <ModalBody>
          {this.state.isUploading ? (
            <div>Uploading image...</div>
          ) : (
            <div>
              <Dropzone
                onDrop={(files: any[]) => this.onDrop(files)}
                className='dropzone cursor-pointer'
              >
                <a className='m-4 text-center'>Click to upload or drag-and-drop</a>
              </Dropzone>
            </div>
          )}
        </ModalBody>
      </Modal>
    )
  }
}
